import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  styled,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SyncIcon from '@mui/icons-material/Sync';
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";

export const ModalConfirmSync = (props: {
  open: boolean;
  onClose: () => void;
  confirm: () => void;
  subTitle?: string;
  loading?: boolean;
}) => {
  return (
    <Modal
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...props}
    >
      <Content
        sx={{
          width: {
            md: "50%",
            xs: "90%",
          },
          maxWidth: {
            lg: "600px",
          },
          p: {
            xs: "20px",
          },
          pt: {
            xs: "20px",
          },
        }}
      >
        <Box
          display="flex"
          alignItems={"start"}
          justifyContent="space-between"
          width="100%"
        >
          <Box width={35} height={35} />
          <Box
            width={70}
            height={70}
            bgcolor={"#2C2C2C"}
            borderRadius={"50%"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
             <SyncIcon sx={{ fontSize: 35, color: "#fff" }} />
          </Box>
          <IconButton onClick={props.onClose} size="small">
            <CloseIcon color="warning" fontSize="large" />
          </IconButton>
        </Box>
        <Box
          display={"flex"}
          flexDirection="column"
          alignItems={"center"}
          gap={1}
        >
          <Typography
            width={"60%"}
            fontWeight="bold"
            fontSize={20}
            textAlign="center"
          >
            Are you sure you want to sync?
          </Typography>
          <Typography
            width={"80%"}
            color="#9B9B9B"
            fontSize={12}
            textAlign="center"
          >
            {props.subTitle ?? "This will update the latest status from the charger."}
          </Typography>
        </Box>

        <Grid container spacing={1} mt={2}>
          <Grid item xs={8}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              startIcon={!props.loading && <TaskAltRoundedIcon fontSize="large" />}
              onClick={props.confirm}
              disabled={props.loading}
            >
              {props.loading ? "Syncing..." : "Confirm"}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              fullWidth
              size="large"
              variant="text"
              onClick={props.onClose}
              disabled={props.loading}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Content>
    </Modal>
  );
};
const Content = styled(Box)({
  background: "#0D0D0D",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  alignItems: "center",
});
